import { jsx } from 'react/jsx-runtime';
import { Row, Column } from '@dls/web';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
const Container = _a => {
  var _b = _a,
    {
      xs = 12,
      sm,
      md,
      lg,
      xl,
      children
    } = _b,
    args = __objRest(_b, ["xs", "sm", "md", "lg", "xl", "children"]);
  const columnProps = {
    xs,
    sm,
    md,
    lg,
    xl
  };
  if (sm === void 0) delete columnProps.sm;
  if (md === void 0) delete columnProps.md;
  if (lg === void 0) delete columnProps.lg;
  if (xl === void 0) delete columnProps.xl;
  return /* @__PURE__ */jsx(Row, {
    children: /* @__PURE__ */jsx(Column, __spreadProps(__spreadValues({}, columnProps), {
      children: Object.keys(args).length ? /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({}, args), {
        children
      })) : children
    }))
  });
};
export { Container as default };